// extracted by mini-css-extract-plugin
export default {"header":"GroupsPageHeader_header__wmih2","btnCont":"GroupsPageHeader_btnCont__EcNbl","large":"GroupsPageHeader_large__bhdsQ"};